<template>
  <div class="card-full-preview">
    <a :href="article.url" class="card">
      <img :src="article.image">
      <div class="card-info">
        <small>{{ article.categoryData.name }}</small>
        <div class="name-container">
          <p v-html="article.original_name"></p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    article: Object
  },
};
</script>

<style scoped lang="scss">
.card-full-preview {
  padding-top: 20px;


  .card {
    width: 315px;
    height: 260px;
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    margin: auto;
    border: 2px solid #F5F5F5;
    border-radius: 8px;

    img {
      position: absolute;
      top: -2px;
      left: -2px;
      width: 315px;
      border-radius: 8px;
      height: 160px;
      object-fit: cover;
    }

    .card-info {
      height: 100px;
      padding: 10px 13px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      small {
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #2F80ED;
      }

      .name-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding-top: 5px;
        padding-bottom: 5px;

        p {
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: #333333;
        }
      }
    }
  }

  .card:focus {
    box-shadow: 0 5px 35px rgba(0, 0, 0, 0.3);
  }
}
</style>
